const YandexAdsPlugin = {
    install(Vue, options = {}) {
        const defaultConfig = {
            debug: process.env.NODE_ENV === 'development',
            enableMock: true,
            mockDelay: 500,
            serverEndpoint: '/api/ads',
            fallbackToYandex: true,
            enableServerAds: true
        }

        const config = { ...defaultConfig, ...options }

        Vue.prototype.$yandexAds = {
            config,

            init() {
                if (config.debug) {
                    console.log('[Yandex Ads] Инициализация')
                }

                if (typeof window !== 'undefined') {
                    if (!window.yaContextCb) {
                        window.yaContextCb = []
                    }

                    if (config.enableMock && config.debug) {
                        this.setupMock()
                    }
                }
            },

            setupMock() {
                if (typeof window === 'undefined') return

                if (!window.Ya) {
                    window.Ya = {}
                }

                if (!window.Ya.Context) {
                    window.Ya.Context = {
                        AdvManager: {
                            render: (params) => {
                                console.log('[Mock Yandex Ads] Рендер блока:', params)
                                return Promise.resolve()
                            },
                            refresh: (blockId) => {
                                console.log('[Mock Yandex Ads] Обновление блока:', blockId || 'всех блоков')
                            }
                        }
                    }
                }
            },

            async getAdFromServer(adUnitId, dimensions, params = {}) {
                if (!config.enableServerAds) {
                    throw new Error('Server ads disabled')
                }

                const queryParams = new URLSearchParams({
                    adUnitId,
                    dimensions,
                    ...params
                })

                const response = await fetch(`${config.serverEndpoint}?${queryParams}`)

                if (!response.ok) {
                    throw new Error(`Server responded with ${response.status}`)
                }

                return response.json()
            },

            loadScript() {
                return new Promise((resolve, reject) => {
                    if (typeof window === 'undefined') {
                        reject(new Error('window is not defined'))
                        return
                    }

                    if (document.getElementById('yandex-ads-script')) {
                        resolve()
                        return
                    }

                    const script = document.createElement('script')
                    script.id = 'yandex-ads-script'
                    script.src = `https://yandex.ru/ads/system/context.js`
                    script.async = true

                    script.onload = () => {
                        console.log('[Yandex Ads] Скрипт загружен')
                        resolve()
                    }

                    script.onerror = (error) => {
                        console.error('[Yandex Ads] Ошибка загрузки скрипта:', error)
                        reject(error)
                    }

                    document.head.appendChild(script)
                })
            },

            refresh(blockId = null) {
                if (config.debug) {
                    console.log('[Yandex Ads] Обновление рекламы', blockId ? `для блока: ${blockId}` : 'всех блоков')
                }

                if (typeof window !== 'undefined' && window.Ya && window.Ya.Context && window.Ya.Context.AdvManager) {
                    if (blockId) {
                        window.Ya.Context.AdvManager.refresh(blockId)
                    } else {
                        window.Ya.Context.AdvManager.refresh()
                    }
                }
            },

            isAvailable() {
                return typeof window !== 'undefined' &&
                    window.Ya &&
                    window.Ya.Context &&
                    window.Ya.Context.AdvManager
            }
        }

        Vue.component('m-ad-block', () => import('@/components/ads/m-ad-block.vue'))
    }
}

export default YandexAdsPlugin